import React, { useState, useEffect, useRef } from 'react';
import { PrimaryButton, SecondaryButton } from '../../../components/forms/buttons';
import { Edit02Icon, Delete01Icon, PlusSignIcon, Search01Icon, TableIcon, TickDouble02Icon, FilterVerticalIcon, Copy01Icon } from 'hugeicons-react';
import { TextInput } from '../../../components/forms/Input';
import api, { API_URL } from '../../../api';
import toast from 'react-hot-toast';
import AddNewMeasureData from '../../../components/forms/measures/MeasureData/AddNewMeasureData';
import BulkAddMeasureData from '../../../components/forms/measures/MeasureData/AddMultipleMeasureData';
import EditMeasureData from '../../../components/forms/measures/MeasureData/EditMeasureData';
import MeasureTooltip from '../../../components/common/MeasureTooltip';
import DeleteMeasureData from '../../../components/forms/measures/MeasureData/DeleteMeasureData';
import '../../../assets/css/pages/measures/measures.css';
import '../../../assets/css/components/forms/bulk-measure-data.css';
import '../../../assets/css/components/forms/measure-action-dialog.css';
import TableLoading from '../../../components/loading/TableLoading';
import DashboardContainer from '../../../components/dashboard/DashboardContainer';

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { hasRole } from '../../../services/userPosition';
import { useGlobalData } from '../../../services/GlobalDataContext';



const MeasuresTable = ({ measures = [], onEditClick, onDeleteClick, onReorder, onSort, currentSort, onFilter, filters }) => {
    const handleDragEnd = (result) => {
        const { source, destination } = result;
        if (!destination) return;

        if (source.index === destination.index) return;

        const updatedMeasures = Array.from(measures);
        const [removed] = updatedMeasures.splice(source.index, 1);
        updatedMeasures.splice(destination.index, 0, removed);

        onReorder(updatedMeasures);
    };

    const [selectedMeasures, setSelectedMeasures] = useState([]);

    const handleSelectMeasure = (measureId) => {
        const index = selectedMeasures.indexOf(measureId);
        if (index === -1) {
            setSelectedMeasures([...selectedMeasures, measureId]);
        } else {
            setSelectedMeasures(selectedMeasures.filter((id) => id !== measureId));
        }
    };


    return !measures || !Array.isArray(measures) || measures.length === 0 ? (
        "No Data Found..."
    ) : (

        <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="measuresTable" className="table-container">
                {(provided) => (
                    <div
                        className="table-container"
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        <table className='draggable'>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Measure Name</th>
                                    <th>Value</th>
                                    <th>Reporting Period Range</th>
                                    <th>Hospital</th>
                                    {
                                        !hasRole(["Admin", "Super User", "Manager"]) ?
                                            <></>
                                            :
                                            <th>Actions</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {measures.map((measure, index) => (
                                    <Draggable
                                        key={measure.measure_data_id}
                                        draggableId={measure.measure_data_id.toString()}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <tr
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <td>{measure.synchronous_id}</td>
                                                <td>{measure.name}</td>
                                                {/* <td>
                                                    <MeasureTooltip
                                                        
                                                        description={measure.description || measure.measure_description}
                                                    />
                                                </td> */}
                                                <td>{measure.value}</td>
                                                <td style={{ whiteSpace: "nowrap", display: "flex", gap: 8, padding: 24 }}>
                                                    {/* <FormattedDate dateString={measure.starting_date} format="display" /> -
                                                    <FormattedDate dateString={measure.end_date} format="display" /> */}
                                                    {measure.starting_date} - {measure.end_date}
                                                </td>
                                                <td>{measure.hospital || "N/A"}</td>

                                                {!hasRole(["Admin", "Super User", "Manager"]) ?
                                                    <></>

                                                    :
                                                    <td>
                                                        <div className="action-buttons">
                                                            <Edit02Icon
                                                                size={32}
                                                                className="edit-icon"
                                                                onClick={() => onEditClick(measure.measure_data_id)}
                                                            />
                                                            {hasRole(["Admin", "Super User", "Manager"]) && (
                                                                <Delete01Icon
                                                                    size={32}
                                                                    className="delete-icon"
                                                                    onClick={() => onDeleteClick(measure.measure_data_id)}
                                                                />
                                                            )}
                                                        </div>
                                                    </td>

                                                }

                                            </tr>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </tbody>
                        </table>
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};




const MeasureDataContent = () => {
    const { rawHospitals, availableYears } = useGlobalData();
    const [measuresData, setMeasuresData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortedData, setSortedData] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [showNewMeasureForm, setShowNewMeasureForm] = useState(false);
    const [showBulkMeasureForm, setShowBulkMeasureForm] = useState(false);
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [constMeasureData, setConstMeasureData] = useState([]);
    const debounceTimeout = useRef(null);
    const [hasSearched, setHasSearched] = useState(false);
    const [editMeasureData, setEditMeasureData] = useState(null);
    const [deleteMeasureData, setDeleteMeasureData] = useState(null);
    const [totalItems, setTotalItems] = useState(0);
    const [nextPage, setNextPage] = useState(null)
    const [previousPage, setPreviousPage] = useState(null);
    // Removed local availableYears state
    const [selectedYear, setSelectedYear] = useState(null);
    const [isOverlayVisible, setIsOverlayVisible] = useState(false);
    const [selectedHospital, setSelectedHospital] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    // Removed local hospitals state
    const [currentSort, setCurrentSort] = useState({ key: '', direction: 'asc' });
    const [filters, setFilters] = useState({});
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const filterPopupRef = useRef(null);
    const [currentDateYear] = useState(new Date().getFullYear());
    const [currentPage, setCurrentPage] = useState(1);
    const yearsFetchedRef = useRef(false);
    const initialLoadRef = useRef(true);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (filterPopupRef.current && !filterPopupRef.current.contains(event.target)) {
                setIsFilterOpen(false);
            }
        };
        if (isFilterOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isFilterOpen]);

    const [dataLoaded, setDataLoaded] = useState(false);

    useEffect(() => {
        if (!dataLoaded) {
            const loadInitialData = async () => {
                // Use data from context
                if (rawHospitals && rawHospitals.length > 0) {
                    if (rawHospitals.length === 1 && !selectedHospital) {
                        setSelectedHospital(rawHospitals[0].name);
                    }
                }

                if (availableYears && availableYears.length > 0 && selectedYear === null) {
                    const currentYear = new Date().getFullYear();
                    setSelectedYear(availableYears.includes(currentYear) ? currentYear : availableYears[0]);
                }

                // If context data is ready (or empty if fetch failed), mark as loaded
                if (rawHospitals && availableYears) {
                    setDataLoaded(true);
                }
            };

            loadInitialData();
        }
    }, [dataLoaded, rawHospitals, availableYears, selectedHospital, selectedYear]);



    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            fetchMeasuresData();
        }
    };
    const handleEditClick = (measure_data_id) => {
        const selectedMeasure = measuresData.find(measure => measure.measure_data_id === measure_data_id);
        setEditMeasureData(selectedMeasure);
    };
    const handleDeleteClick = (measure_data_id) => {
        const selectedMeasure = measuresData.find(measure => measure.measure_data_id === measure_data_id);
        setDeleteMeasureData({
            synchronousId: selectedMeasure?.synchronous_id,
            measureDataId: selectedMeasure?.measure_data_id
        });
    };

    const handleDurationYearChange = (value) => {
        setSelectedYear(value)
    };
    const fetchMeasuresData = async (query = searchQuery, url = null) => {
        setIsOverlayVisible(true);
        setIsSearching(true);

        try {
            let response;
            const params = {
                search: query || undefined,
                measure_year: selectedYear || undefined,
                hospital_name: selectedHospital || undefined,
                month: selectedMonth || undefined
            };

            if (url) {
                const urlObj = new URL(url);
                const relativePath = urlObj.pathname.substring(4) + urlObj.search;
                response = await api.get(relativePath);
            } else {
                response = await api.get(`${API_URL}/measures/measures_hospital_list/`, { params });
            }

            console.log("Fetched Data:", response.data.results);

            const sortedMeasures = response.data.results.sort(
                (a, b) => new Date(a.date_created) - new Date(b.date_created)
            );

            setMeasuresData(sortedMeasures);
            setSortedData(sortedMeasures);
            setConstMeasureData(sortedMeasures);
            setHasSearched(true);
            setNextPage(response.data.next);
            setPreviousPage(response.data.previous);
            setTotalItems(response.data.count);

        } catch (err) {
            if (err.response?.status === 404) {
                setMeasuresData([]);
                setNextPage(null);
                setPreviousPage(null);
                toast.error('No more pages available.');
            } else {
                console.error('Error fetching data:', err);
                toast.error('Failed to load measure data.');
            }
        } finally {
            setIsOverlayVisible(false);
            setIsSearching(false);
        }
    };

    const handleInputChange = (value) => {
        setSearchQuery(value);
        clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
            fetchMeasuresData(value);
        }, 300);
    };



    const changePage = async (url, direction) => {
        await fetchMeasuresData(searchQuery, url);
        setCurrentPage((prev) => direction === 'next' ? prev + 1 : prev - 1);
    }

    useEffect(() => {
        if (dataLoaded && !initialLoadRef.current) {
            fetchMeasuresData();
        } else if (dataLoaded && initialLoadRef.current) {
            initialLoadRef.current = false;
            fetchMeasuresData();
        }
        return () => {
            clearTimeout(debounceTimeout.current);
        };
    }, [selectedYear, selectedHospital, selectedMonth, dataLoaded]);

    // Cleanup popups when component unmounts
    useEffect(() => {
        return () => {
            setShowAddDialog(false);
            setShowNewMeasureForm(false);
            setShowBulkMeasureForm(false);
            setEditMeasureData(null);
            setDeleteMeasureData(null);
        };
    }, []);


    const handleSort = (sortConfig) => {
        setCurrentSort(sortConfig);

        const sortedData = [...measuresData].sort((a, b) => {
            const aValue = a[sortConfig.key] || '';
            const bValue = b[sortConfig.key] || '';

            if (typeof aValue === 'string' && typeof bValue === 'string') {
                const comparison = aValue.toLowerCase().localeCompare(bValue.toLowerCase());
                return sortConfig.direction === 'asc' ? comparison : -comparison;
            }

            if (typeof aValue === 'number' && typeof bValue === 'number') {
                return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
            }

            const comparison = String(aValue).localeCompare(String(bValue));
            return sortConfig.direction === 'asc' ? comparison : -comparison;
        });

        setMeasuresData(sortedData);
    };

    const handleFilter = (column, value) => {
        const newFilters = { ...filters, [column]: value };
        setFilters(newFilters);

        let filteredData = [...measuresData];

        Object.keys(newFilters).forEach(key => {
            const filterValue = newFilters[key];
            if (filterValue) {
                filteredData = filteredData.filter(measure => {
                    const measureValue = measure[key] || '';
                    return measureValue.toString().toLowerCase().includes(filterValue.toLowerCase());
                });
            }
        });

        setMeasuresData(filteredData);
    };

    const handleReorder = (updatedMeasures) => {
        // For now, just update the local state
        // In the future, this could make an API call to persist the order
        setMeasuresData(updatedMeasures);
    };

    const removeMeasureFromState = (measureDataId) => {
        setMeasuresData(prev => prev.filter(measure => measure.measure_data_id !== measureDataId));
        setSortedData(prev => prev.filter(measure => measure.measure_data_id !== measureDataId));
        setConstMeasureData(prev => prev.filter(measure => measure.measure_data_id !== measureDataId));
    };


    return (
        <div className='measures-page'>
            {showNewMeasureForm && (
                <div className="popup new-measure-form-popup">
                    <div className="popup-content">
                        <AddNewMeasureData
                            setShowNewMeasureFrom={setShowNewMeasureForm}
                            onClose={() => setShowNewMeasureForm(false)}
                            onAddSuccess={fetchMeasuresData}
                            year={selectedYear}
                        />
                    </div>
                </div>
            )}

            {showBulkMeasureForm && (
                <BulkAddMeasureData
                    onClose={() => setShowBulkMeasureForm(false)}
                    onAddSuccess={fetchMeasuresData}
                />
            )}
            {editMeasureData && (
                <div className="popup edit-measure-data-popup">
                    <div className="popup-content">
                        <EditMeasureData
                            measure_data_id={editMeasureData.measure_data_id}
                            measureData={editMeasureData}
                            onClose={() => setEditMeasureData(null)}
                            onSubmit={fetchMeasuresData}
                            selectedYear={selectedYear}
                        />
                    </div>
                </div>
            )}

            {
                deleteMeasureData && (
                    <div className="popup delete-measure-data-popup">
                        <div className="popup-content">
                            <DeleteMeasureData
                                measureId={deleteMeasureData}
                                isOpen={!!deleteMeasureData}
                                onClose={() => setDeleteMeasureData(null)}
                                removeMeasure={removeMeasureFromState}
                                measureName={measuresData.find(m => m.measure_data_id === deleteMeasureData?.measureDataId)?.name}
                            />
                        </div>
                    </div>
                )
            }

            <div className="buttons-search">
                <div className="search-button">
                    <TextInput
                        type="text"
                        name="search"
                        placeholder="Search measure name..."
                        value={searchQuery}
                        setValue={handleInputChange}
                        icon={<Search01Icon />}
                        onKeyDown={handleKeyDown}
                    />
                </div>
                <div className='buttons'>
                    <SecondaryButton
                        className="filter-button"
                        onClick={() => setIsFilterOpen((prev) => !prev)}
                        iconClass={<FilterVerticalIcon />}
                        buttonText="Filter"
                    />
                    {hasRole(['Admin', 'Super User', 'Manager']) && (
                        <PrimaryButton
                            iconClass={<PlusSignIcon />}
                            buttonText="Add Measure Data"
                            onClick={() => setShowAddDialog(true)}
                        />
                    )}

                    {(selectedYear || selectedHospital || selectedMonth) && (
                        <div className="filter-summary">
                            {/* <span className="filter-label"><h3>Active Filters:</h3></span> */}
                            <div className="filter-tags">
                                {selectedYear && (
                                    <span className="filter-tag">
                                        <h3>Year:</h3>
                                        <span>{selectedYear}</span>
                                    </span>
                                )}
                                {selectedHospital && (
                                    <span className="filter-tag">
                                        <h3>Hospital:</h3>
                                        <span>{selectedHospital}</span>
                                    </span>
                                )}
                                {selectedMonth && (
                                    <span className="filter-tag">
                                        <h3>Month:</h3>
                                        <span>{new Date(0, selectedMonth - 1).toLocaleString('default', { month: 'long' })}</span>
                                    </span>
                                )}

                            </div>
                            {(selectedYear || selectedHospital || selectedMonth) && (

                                <p className="clear-all-filters"
                                    onClick={() => {
                                        setSelectedYear(null);
                                        setSelectedHospital('');
                                        setSelectedMonth('');
                                        fetchMeasuresData(searchQuery);
                                    }}>Clear All</p>


                            )}
                        </div>
                    )}
                </div>



                {showAddDialog && (
                    <div
                        className="measure-action-overlay"
                        onClick={e => {
                            if (e.target.classList.contains('measure-action-overlay')) setShowAddDialog(false);
                        }}
                    >
                        <div className="measure-action-dialog" onClick={e => e.stopPropagation()}>
                            <h2>Add Measure Data</h2>
                            <p>Choose how you want to add measure data</p>
                            <div className="action-options">
                                <div className="action-option" onClick={() => { setShowAddDialog(false); setShowNewMeasureForm(true); }}>
                                    <div className="option-icon create-icon">
                                        <PlusSignIcon size={24} />
                                    </div>
                                    <div className="option-content">
                                        <h3>Single Measure Data</h3>
                                        <p>Add one measure data entry at a time</p>
                                    </div>
                                </div>
                                <div className="action-option" onClick={() => { setShowAddDialog(false); setShowBulkMeasureForm(true); }}>
                                    <div className="option-icon copy-icon">
                                        <Copy01Icon size={24} />
                                    </div>
                                    <div className="option-content">
                                        <h3>Multiple Measure Data</h3>
                                        <p>Add multiple measure data entries in bulk</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}


                {isFilterOpen && (
                    <div
                        className="filter-popup"
                        ref={filterPopupRef}
                        onClick={e => {
                            if (e.target === filterPopupRef.current) setIsFilterOpen(false);
                        }}
                    >
                        <div className="filter-section" onClick={e => e.stopPropagation()}>
                            <div className="filter-item">
                                <label>Year</label>
                                <select
                                    className="year-select"
                                    value={selectedYear}
                                    onChange={(e) => setSelectedYear(e.target.value)}
                                >
                                    {Array.isArray(availableYears) && availableYears.length > 0 ? (
                                        availableYears.map((year) => (
                                            <option key={year} value={year}>{year}</option>
                                        ))
                                    ) : (
                                        <option value={selectedYear}>{selectedYear}</option>
                                    )}
                                </select>
                            </div>
                            <div className="filter-item">
                                <label>Hospital</label>
                                <select
                                    className="hospital-select"
                                    value={selectedHospital}
                                    onChange={(e) => setSelectedHospital(e.target.value)}
                                >
                                    <option value="">All Hospitals</option>
                                    {rawHospitals && rawHospitals.map(hospital => (
                                        <option key={hospital.id} value={hospital.name}>{hospital.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="filter-item">
                                <label>Month</label>
                                <select
                                    className="month-select"
                                    value={selectedMonth}
                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                >
                                    <option value="">All Months</option>
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                            </div>
                            <button className="reset-button" onClick={() => {
                                // setSelectedYear(new Date().getFullYear());
                                setSelectedYear(currentDateYear);
                                setSelectedHospital('');
                                setSelectedMonth('');
                                setIsFilterOpen(false);
                                fetchMeasuresData();
                            }}>Reset Filter</button>
                            <button className="apply-button" onClick={() => {
                                setIsFilterOpen(false);
                                fetchMeasuresData();
                            }}>Close</button>
                        </div>
                    </div>
                )}
            </div>



            <div className="measures table-container">
                {isOverlayVisible && <TableLoading />}
                {hasSearched && measuresData.length === 0 ? (
                    <div className="no-data-message">
                        <p>No Data Found for the selected filters.</p>
                        {(selectedYear || selectedHospital || selectedMonth) && (
                            <p className="filter-info">
                                Current filters: {selectedYear && `Year: ${selectedYear}`}
                                {selectedHospital && ` | Hospital: ${selectedHospital}`}
                                {selectedMonth && ` | Month: ${new Date(0, selectedMonth - 1).toLocaleString('default', { month: 'long' })}`}
                            </p>
                        )}
                        <p className="suggestion">Try adjusting your filters or add new measure data.</p>
                    </div>
                ) : (
                    <MeasuresTable
                        measures={measuresData}
                        onEditClick={handleEditClick}
                        onDeleteClick={handleDeleteClick}
                        onReorder={handleReorder}
                        onSort={handleSort}
                        currentSort={currentSort}
                        onFilter={handleFilter}
                        filters={filters}
                    />
                )}
            </div>

            <div className="pagination-controls">
                <button
                    className={`previous ${previousPage === null ? 'disabled' : ''}`}
                    onClick={() => changePage(previousPage, 'prev')}
                    disabled={previousPage === null}
                >
                    Previous
                </button>
                <span>Page {currentPage}</span>
                <button
                    className={`next ${!nextPage ? 'disabled' : ''}`}
                    onClick={() => changePage(nextPage, 'next')}
                    disabled={!nextPage}
                >
                    Next
                </button>
            </div>


        </div>
    );
};

const MeasureDataPage = () => {
    return (
        <DashboardContainer content={<MeasureDataContent />} pageTitle={'Measure Data'} />
    );
};

export default MeasureDataPage;
